import classNames from "classnames";
import React from "react";
import styles from "./icons.css";

interface Props {
  isExpanded: boolean;
  onClick(): void;
}
export const ElementFormExpandIcon = ({ isExpanded, onClick }: Props) => {
  return (
    <i
      onClick={onClick}
      className={classNames("icon-arrow-up", styles["expand-icon"], {
        [styles["non-expanded"]]: !isExpanded
      })}
    />
  );
};
